import { Card, Typography } from 'antd';

type ActionCardProps = {
  icon: React.JSXElementConstructor<{ className: string }>;
  title: string;
  id?: string;
  onClick?: () => void;
};

const ActionCard = ({ icon: Icon, title, onClick, id }: ActionCardProps) => {
  return (
    <Card
      size='small'
      id={id}
      onClick={onClick}
      className='hover:border-primary cursor-pointer'
      classNames={{
        body: 'md:h-68 md:w-60.5 justify-center items-center flex-col flex gap-3'
      }}
    >
      <span className='dark:bg-secondary-50/10 flex h-14 w-14 items-center justify-center rounded-full bg-sky-100'>
        <Icon className='text-primary h-8 w-8' />
      </span>

      <Typography.Title level={5} className='text-primary mb-0 text-center md:min-h-12'>
        {title}
      </Typography.Title>
    </Card>
  );
};

export default ActionCard;
